import { MessageSquare } from 'lucide-react';

import { NodeShell } from './NodeShell';

interface SendSmsNodeData {
  label: string;
  to?: string;
  waMessageType?: 'template' | 'contacts';
}

export const SendSmsNode = ({ data, selected }: { data: SendSmsNodeData; selected?: boolean }) => (
  <NodeShell
    type="send_sms"
    icon={<MessageSquare size={16} />}
    label={data.label}
    subtitle={
      data.waMessageType === 'contacts'
        ? `Contact card${data.to ? ` → ${data.to}` : ''}`
        : data.to
          ? `To: ${data.to}`
          : undefined
    }
    selected={selected}
    sources={[
      {
        id: 'sent',
        top: '32%',
        handleClass: '!bg-green-500',
        label: 'sent',
        labelClass: 'text-green-600',
      },
      {
        id: 'failed',
        top: '68%',
        handleClass: '!bg-red-500',
        label: 'failed',
        labelClass: 'text-red-600',
      },
    ]}
  />
);
